import type { FC } from 'react';
import type { DbooButtonProps } from './dboo-button.types';
import type { LinksFunction } from '@remix-run/node';
import clsx from 'clsx';

import { SharedIcon } from '@/components/shared/shared-icon/shared-icon';

import styles from './dboo-button.css?url';

export const links: LinksFunction = () => {
  return [{ rel: 'stylesheet', href: styles }];
};

export const DbooButton: FC<DbooButtonProps> = ({
  children,
  fullWidth,
  variant,
  className,
  loading,
  ...rest
}) => {
  const classes = clsx('dboo-button', className, {
    'dboo-button--full-width': fullWidth,
    'dboo-button--loading': loading,
    'dboo-button--primary': variant === 'primary',
    'dboo-button--secondary': variant === 'secondary',
    'dboo-button--ghost': variant === 'ghost',
    'dboo-button--outline': variant === 'outline',
  });

  return (
    <button className={classes} {...rest}>
      {!loading && children}
      {loading && <SharedIcon name="loader" />}
    </button>
  );
};
